import { Card, Container, Flex, Spinner } from '@nrx/ui';
import type { JSX } from 'react';

/**
 * Shown while the magic-link exchange is in flight.
 *
 * @remarks `Spinner message` owns both the glyph and the visible copy, so the wait is announced
 * (`role="status"`, `aria-busy`) instead of sitting in a silent div — W1/W4. The width comes from
 * the same `Container size="4"` the shell header and footer use, so this state lines up with the
 * brand lockup rather than the vendor's hardcoded 940px.
 */
export function ConsultLoadingState(): JSX.Element {
  return (
    <Container as="section" size="4" pt="8" pb="10">
      <Card elevation="soft" className="consult-panel">
        <Flex justify="center" py="6">
          <Spinner message="Loading..." />
        </Flex>
      </Card>
    </Container>
  );
}
